module.exports = __webpack_public_path__ + "static/media/Saly-26.da773758.png";